<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="printList">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">打印</el-dropdown-item>
              <el-dropdown-item command="1">预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
            @click="showTransfer">自定义设置</el-button>
          <!-- <div class="search">
            <input type="text" v-model="query.keyWord"  />
            <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i>
          </div>
          <span v-preventReClick @click="reset">重置</span> -->
        </div>
      </div>
      <div v-if="tableHaeder.length > 0">
        <CustomTable ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange"
          :tableHaeder="tableHaeder" :loading="loading" @resetMethod="reset" :tableHeight="tableHeight"
          @onApproveStatusSuccess="getData" :tableCode="route.name">
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">

          </template>
        </CustomTable>
      </div>
      <div v-else>
        <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight"
          style="width: 100%" @selection-change="handleSelectionChange" stripe
          :header-cell-style="{ background: '#DDEBFF' }">
          <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template>
          <el-table-column min-width="150" show-overflow-tooltip prop="productName" fixed
            label="产品名称"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="specName" fixed label="规格型号"></el-table-column>

          <el-table-column prop="batch" label="批次号" width="100">
            <template slot-scope="scope">
              {{ scope.row.batch?scope.row.batch:'-' }}
            </template>
          </el-table-column>
          <el-table-column prop="serialNo" label="序列号" width="100">
            <template slot-scope="scope">
              {{ scope.row.serialNo?scope.row.serialNo:'-' }}
            </template>
          </el-table-column>
          <el-table-column prop="manufactureDate" label="生产日期" width="120">
            <template slot-scope="scope">
              {{ scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : "-" }}
            </template>
          </el-table-column>
          <el-table-column prop="validityDate" label="有效期" width="120">
            <template slot-scope="scope">
              {{ scope.row.validityDate ? parseTime( new Date(scope.row.validityDate),"{y}-{m}-{d}"): "-"}}
            </template>
          </el-table-column>
          <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="categoryName" label="类型"></el-table-column>

          <el-table-column min-width="120" show-overflow-tooltip prop="warehouseName" label="仓库/科室">
            <template slot-scope="scope">{{
              scope.row.category == 1 ? scope.row.warehouseName : scope.row.deptName
              }}</template>
          </el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="supplierName" label="供应商"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="manufacturerName" label="生产厂家"></el-table-column>
          <el-table-column width="120" prop="date" label="日期">
            <template slot-scope="scope">{{
              parseTime(new Date(scope.row.date), "{y}-{m}-{d}")
              }}</template>
          </el-table-column>
          <el-table-column min-width="100" prop="amount" label="损益金额"></el-table-column>
          <el-table-column min-width="100" prop="number" label="损益数量"></el-table-column>
          <el-table-column min-width="100" prop="oldPrice" label="调整前价格"></el-table-column>
          <el-table-column min-width="100" prop="newPrice" label="调整后价格"></el-table-column>

          <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
            width="200"></el-table-column>
          <el-table-column width="160" prop="effectiveTime" label="生效时间">
            <template slot-scope="scope">
              <div>
                {{ parseTime(new Date(scope.row.effectiveTime), "{y}-{m}-{d}") }}
              </div>
              <div>
                {{ parseTime(new Date(scope.row.effectiveTime), "{h}:{i}:{s}") }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetStockGainsLosss,
  GetStockGainsLossPrintData,
  ExportStockGainsLosss,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import { StockCategoryOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetStockGainsLosss,
      exportAction: ExportStockGainsLosss,
      // RemoveAction: RemoveAcceptInStock,
      // PrintAction: GetStockGainsLossPrintData,
      // editPath: 'accept-in-stock-edit',

      // StockCategoryOptions: StockCategoryOptions,
      filterOptions: [{
        name: "供货商产品",
        type: "select",
        code: "supplierProductId",
        filterMethod: this.getSupplierProductsNoDebounce,
        data: [],
      },
      {
        name: "供应商产品编码",
        type: "input",
        code: "supplierProductNo",
      },
      {
        name: "产品名称",
        type: "input",
        code: "productName",
      },
      {
        name: "规格型号",
        type: "input",
        code: "specName",
      },
      {
        name: "供应商",
        type: "select",
        code: "supplierId",
        filterMethod: this.getSuppliers,
        data: [],
      },
      {
        name: "生产厂家",
        type: "select",
        code: "manufacturerId",
        filterMethod: this.getManufacturers,
        data: [],
      },
      {
        name: "库房",
        type: "select",
        code: "warehouseId",
        filterMethod: this.getWarehouses,
        data: [],
      },
      {
        name: "日期范围",
        type: "date",
        code: "date",
      },
        {
          name: "批次号",
          type: "input",
          code: "batch",
        },
        {
          name: "序列号",
          type: "input",
          code: "serialNo",
        },
      ],
    };
  },
  methods: {
    printList(command) {
      this.query.type = command;

      GetStockGainsLossPrintData(this.query).then((res) => {
        var result = res.returnData;

        var printData = this.printDataConvert(result.printData);
        this.sendPrintMessage(JSON.stringify(printData));
      });
    },
  },
  mounted() { },
};
</script>

<style lang="scss" scoped></style>
